import { areArraysEqual } from '../areArraysEqual';
/**
 *
 * Returns true if array contains the given object
 *
 * @template T
 * @param {T} object
 * @param {T[]} arrayOfObjects
 * @returns {boolean}
 *
 * @example
 * doesArrayContainTheGivenObject({x: 10, y: 12}, [{x: 10, y: 12},{a: 1, b: 2},{o: 5, p: 25}])
 * // returns true
 */
export var doesArrayContainTheGivenObject = function (object, arrayOfObjects) {
    var result = false;
    arrayOfObjects.forEach(function (value) {
        if (areArraysEqual(Object.keys(object), Object.keys(value))
            && areArraysEqual(Object.values(object), Object.values(value)))
            result = true;
        return result;
    });
    return result;
};
//# sourceMappingURL=doesArrayContainTheGivenObject.js.map